export default "__VITE_ASSET__BFZ8clWq__"